import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { FloatingFocusManager } from "@floating-ui/react";
import { isWeb } from "@tamagui/core";
import { styled } from "@tamagui/core";
import { PortalItem } from "@tamagui/portal";
import { ThemeableStack } from "@tamagui/stacks";
import * as React from "react";
import { VIEWPORT_NAME } from "./constants";
import { ForwardSelectContext, useSelectContext } from "./context";
import { useSelectBreakpointActive } from "./useSelectBreakpointActive";
const SelectViewportFrame = styled(ThemeableStack, {
  name: VIEWPORT_NAME,
  backgroundColor: "$background",
  elevate: true,
  bordered: true,
  userSelect: "none",
  outlineWidth: 0,
  variants: {
    size: {
      "...size": (val, { tokens }) => {
        return {
          borderRadius: tokens.radius[val] ?? val
        };
      }
    }
  },
  defaultVariants: {
    size: "$2"
  }
});
const SelectViewport = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, children, disableScroll, ...viewportProps } = props;
    const context = useSelectContext(VIEWPORT_NAME, __scopeSelect);
    const breakpointActive = useSelectBreakpointActive(context.sheetBreakpoint);
    if (context.shouldRenderWebNative) {
      return /* @__PURE__ */ jsx(Fragment, { children });
    }
    if (breakpointActive || !isWeb) {
      return /* @__PURE__ */ jsx(PortalItem, { hostName: `${context.scopeKey}SheetContents`, children: /* @__PURE__ */ jsx(ForwardSelectContext, { context, children }) });
    }
    if (!context.floatingContext) {
      return null;
    }
    if (!context.open) {
      return /* @__PURE__ */ jsx(Fragment, { children });
    }
    const {
      style: { scrollbarWidth, listStyleType, overflow, ...restStyle },
      ...floatingProps
    } = context.interactions.getFloatingProps();
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      !disableScroll && /* @__PURE__ */ jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: selectViewportCSS
          }
        }
      ),
      /* @__PURE__ */ jsx(FloatingFocusManager, { context: context.floatingContext, children: /* @__PURE__ */ jsx(
        SelectViewportFrame,
        {
          size: context.size,
          role: "presentation",
          ...viewportProps,
          ref: forwardedRef,
          ...floatingProps,
          ...restStyle,
          overflow: disableScroll ? void 0 : overflow ?? "scroll",
          children
        }
      ) })
    ] });
  }
);
SelectViewport.displayName = VIEWPORT_NAME;
const selectViewportCSS = `
.is_SelectViewport {
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.is_SelectViewport::-webkit-scrollbar{
  display:none
}
`;
export {
  SelectViewport,
  SelectViewportFrame
};
//# sourceMappingURL=SelectViewport.js.map
